export enum listType {
    DirectActivations = 'DirectActivations',
    FormSons = 'FormSons'
}
